var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryUy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_7955)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_7955",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_7955)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 2.66663H13.3333V5.33329H28V2.66663ZM13.3333 7.99996V10.6666H28V7.99996H13.3333ZM13.3333 13.3333L0 13.3333V16H28V13.3333H13.3333ZM0 20V18.6666H28V20H0Z",
    fill: "#0E4DC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66675 9.32136L5.77666 10.65L5.55121 9.06674L4.17279 9.87762L4.65661 8.35333L3.06287 8.48583L4.16015 7.32241L2.66675 6.7503L4.16015 6.17818L3.06287 5.01476L4.65661 5.14727L4.17279 3.62297L5.55121 4.43385L5.77666 2.85059L6.66675 4.17924L7.55683 2.85059L7.78229 4.43385L9.16071 3.62297L8.67689 5.14727L10.2706 5.01476L9.17335 6.17818L10.6667 6.7503L9.17335 7.32241L10.2706 8.48583L8.67689 8.35333L9.16071 9.87762L7.78229 9.06674L7.55683 10.65L6.66675 9.32136ZM6.66675 9.29575C8.07256 9.29575 9.2122 8.15611 9.2122 6.7503C9.2122 5.34448 8.07256 4.20484 6.66675 4.20484C5.26093 4.20484 4.12129 5.34448 4.12129 6.7503C4.12129 8.15611 5.26093 9.29575 6.66675 9.29575ZM8.66675 6.66672C8.66675 7.77129 7.77132 8.66672 6.66675 8.66672C5.56218 8.66672 4.66675 7.77129 4.66675 6.66672C4.66675 5.56215 5.56218 4.66672 6.66675 4.66672C7.77132 4.66672 8.66675 5.56215 8.66675 6.66672Z",
    fill: "#FED443"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_7955"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryUy);
export default __webpack_public_path__ + "static/media/Country=UY.066a8d50bc9f88581fc2fdd2046a6797.svg";
export { ForwardRef as ReactComponent };